@if (isDebugMode) {
  <mat-expansion-panel class="collection-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="panel-icon">debug</mat-icon>
        Debug
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="editor-data-holder">
      <form [formGroup]="editorForm" (ngSubmit)="onUpdate()" class="form-container">
        <h2>Editor Configuration</h2>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Collabora URL</mat-label>
          <input matInput type="url" formControlName="collaboraUrl" placeholder="e.g., https://collabora.example.com" />
        </mat-form-field>
        <mat-checkbox formControlName="useConfigForDriftApi" class="config-checkbox">
          Use configuration for Drift API
        </mat-checkbox>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Drift API Key</mat-label>
          <input matInput type="text" formControlName="driftApi" placeholder="Enter Drift API Key" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Document Id</mat-label>
          <input matInput type="text" formControlName="documentId" placeholder="Enter Document Id" />
        </mat-form-field>

        <mat-divider class="my-3"></mat-divider>
        <mat-checkbox formControlName="useConfigForAccessToken" class="config-checkbox">
          Use configuration for Access Token
        </mat-checkbox>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Access Token (JWT)</mat-label>
          <input matInput type="text" formControlName="accesstoken" placeholder="Enter JWT Access Token" />
        </mat-form-field>

        <div class="button-row">
          <button mat-raised-button color="primary" type="submit" [disabled]="editorForm.invalid">
            <mat-icon>save</mat-icon> Save Configuration
          </button>
        </div>
      </form>

      <div class="urls">
        <h2>Generated WOPI and Editor URLs</h2>

        <mat-card class="url-card">
          <mat-card-header>
            <mat-card-title>WOPI File URL</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p class="url-value">{{ generatedWopiUrl }}</p>
          </mat-card-content>
        </mat-card>

        <mat-card class="url-card">
          <mat-card-header>
            <mat-card-title>Editor Iframe src</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p class="url-value" [innerHTML]="generatedEditorSrc"></p>
          </mat-card-content>
        </mat-card>
        <button (click)="openEditorInNewWindow()" mat-raised-button color="primary">Open editor in new window</button>
        <button (click)="openEditorHere()" mat-raised-button color="primary">Open editor here</button>
      </div>
    </div>
  </mat-expansion-panel>
}
<div class="status-bar">
  <app-persona-review></app-persona-review>
  @if (collabraService.exportFormats | async; as exportFormats) {
    <button mat-icon-button [matMenuTriggerFor]="menu" color="accent">
      <mat-icon>publish</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if (exportFormats && exportFormats.length > 0) {
        @for (format of exportFormats; track $index) {
          <button (click)="collabraService.exportDocument(format.Format)" mat-menu-item>
            <mat-icon>doc</mat-icon>
            <span>{{ format.Label }}</span>
          </button>
        }
      } @else {
        <button [disabled]="true" mat-menu-item>
          @if (!collabraService.isCollabraIframeInitialized) {
            <mat-icon> <mat-progress-spinner [diameter]="25" [mode]="'indeterminate'"></mat-progress-spinner></mat-icon>
          }
          <span>No extension found</span>
        </button>
      }
    </mat-menu>
  }
</div>
@if (editorIsOpen) {
  @if (documentStatus.status !== 'IN_PROGRESS') {
    <app-editor-iframe [workspaceId]="workspaceId" [collaboraIframeUrl]="generatedEditorSrc"></app-editor-iframe>
  } @else {
    <app-ai-drafting-progress></app-ai-drafting-progress>
  }
}
